var zh = {
    name01: "Smart Cabinet Overview",
    name02: "Operation Records",
    name03: "Pick-up Records",
    name04: "Return Records",
    name05: "Pending Return Reagent Records",
    name06: "Pending Disposal Reagent Records",
    name07: "Insufficient Inventory Information",
    name08: "Overdue Unreturned Records",
    name09: "Imminent Expiry Reagents",
    name10: "Unweighed Return Records",
    name11: "Personnel Management",
    name12: "Reagent Management",
    name13: "In-stock Reagents",
    name14: "Disposal Request",
    name15: "Violation Management",
    name16: "Search",
    name17: "Report Management",
    name18: "Chemical Monthly Report",
    name19: "Hazardous Chemical Monthly Report",
    name20: "Hazardous Chemical Usage Report",
    name21: "System Settings",
    name22: "Company Information",
    name23: "College Information",
    name24: "Violation Conditions",
    name25: "Reagent Categories",
    name26: "Reagent Configuration",
    name27: "Manufacturer Configuration",
    name28: "Device Status",
    name29: "Email Configuration",
    name30: "APK Upgrade",
    name31: "Smart Cabinet Terminal Logs",
    name32: "Application Management",
    name33: "My Applications",
    name34: "Application Processing",
    name35: "Excel Import",
    name36: "Handheld Inventory Records",
    name37: "All",
    name38: "Back",
    name39: "More Filters (Expand)",
    name40: "More Filters (Collapse)",
    name41: "save",
    name42: "Save and submit",
    main: {
        name01: "Smart Cabinet Management System",
        name02: "Search",
        name03: "Add",
        name04: "Edit",
        name05: "Delete",
        name06: "Operation",
        name07: "Cancel",
        name08: "Confirm",
        name09: "Yes",
        name10: "No",
        name11: "Start Time",
        name12: "End Time",
        name13: "All",
        name14: "Unable to connect to the server, please check the network!",
        name15: "You do not have permission to access the system. Please log in again or contact the administrator!",
        name16: "Batch Processing",
        name17: "Label Printing",
        name18: "Sheets",
        name19: "Edit Selected",
        name20: "Delete Selected",
        name21: "Show Columns",
        name22: "More Actions",
        name23: "Print",
        name24: "Details",
        name25: "Close",
        name26: "Not Selected",
        name27: "Next",
        name28: "Previous",
        name29: "Submit",
        name30: "No Data Available",
        name31: "Added Successfully",
        name32: "Stock In Export",
        name33: "Return",
        name34: "Authorize Permissions",
        name35: "View Permissions",
        name36: "Add Subitem",
        name37: "Single Add",
        name38: "Batch Add",
        name39: "View Details",
        name40: "Edit Cabinet Door",
        name41: "More Settings",
        name42: "Edit Cabinet",
        name43: "Functionality",
        name44: "Remote Inventory",
        name45: "Sync Face",
        name46: "View Video",
        name47: "View Inventory",
        name48: "Specify Smart Cabinet",
        name49: "Select All",
        enable: "Enable",
        disable: "Disable",


    },
    login: {
        name1: "Smart Cabinet Management System",
        name2: "Login",
        name3: "Mobile Number",
        name4: "Password",
        name5: "Mobile number cannot be empty",
        name6: "Password cannot be empty",
        name7: "Chemical Intelligent Reagent Cabinet Management System V2.1.0",
        name8: "Change Password",
        name9: "Log Out",
        name10: "Old Password",
        name11: "New Password",
        name12: "Confirm Password"
    },
    cabinet: {
        name01: "Number",
        name02: "Enter Smart Cabinet Number",
        name03: "Name",
        name04: "Enter Smart Cabinet Name",
        name05: "Multi-Door Cabinet",
        name06: "Enter Total Door Count",
        name07: "Smart Cabinet Type",
        name08: "Select Smart Cabinet Type",
        name09: "Smart Cabinet Control Type",
        name10: "Select Smart Cabinet Control Type",
        name11: "Control Cabinet",
        name12: "Select Control Cabinet",
        name13: "Storage Category",
        name14: "Select Hazard Category",
        name15: "Company",
        name16: "Select Custodian Company",
        name17: "College",
        name18: "Select Custodian College",
        name19: "Location",
        name20: "Enter Custodian Location",
        name21: "Capacity cannot be empty",
        name22: "Capacity must be a positive integer",
        name23: "RFID Cabinet",
        name24: "Barcode Cabinet",
        name25: "Storage Cabinet",
        name26: "Control Cabinet",
        name27: "Integrated Cabinet",
        name28: "Smart Cabinet Number cannot be empty",
        name29: "Smart Cabinet Name cannot be empty",
        name30: "Edit Smart Cabinet",
        name31: "Add Smart Cabinet",
        name32: "Disposal of This Smart Cabinet",
        name33: "Door Lock",
        name34: "Fan",
        name35: "Inventory",
        name36: "Liquid",
        name37: "Solid",
        name38: "Operations Today",
        name39: "Borrowed Today",
        name40: "Returned Today",
        name41: "Select Cabinet Door",
        name42: "Edit Information",
        name43: "Used Today",
        name44: "View Inventory",
        name45: "Temperature",
        name46: "Humidity",
        name47: "VOC",
        name48: "Smart Cabinet",
        name49: "Confirm Disposal of This Smart Cabinet Information!",
        name50: "Disposal of Smart Cabinet",
        name51: "Successfully Deleted Smart Cabinet Information!",
        name52: "Online",
        name53: "Offline",
        name54: "Exhaust Fan",
        name55: "Smart Cabinet Status",
        name56: "Total Devices (Units)",
        name57: "Total Inventory (Bottles)",
        name58: "Data Today",
        name59: "Special Tips Today",
        name60: "Operations Today",
        name61: "Exceptions Today",
        name62: "Pick-ups Today",
        name63: "Returns Today",
        name64: "Pending Returns",
        name65: "Pending Disposals",
        name66: "Insufficient Inventory",
        name67: "Overdue Unreturns",
        name68: "Imminent Expiry",
        name69: "Unweighed Returns",
        name70: "Times",
        name71: "count",
        name72: "Bottles",
        name73: "Type",
        name74: "Weight",
        name75: "All Smart Cabinets",
        name76: "Convenient Search by Number",
        name77: "Current Capacity",
        name78: "Total Capacity",
        name79: "Refresh",
        name80: "Other Configurations",
        name81: "Enter Other Configurations (Recommend using JSON string)",
        name82: "Sort",
        name83: "Smart Cabinet Serial Number",
        name84: "Has Temperature Sensor",
        name85: "Has Humidity Sensor",
        name86: "Has Smart Lock",
        name87: "Has Fan",
        name88: "Has VOC Sensor",
        name89: "Location Abbreviation",
        name90: "Enter Abbreviation for Storage Location",
        name91: "Regular Cabinet",
        name92: "Has Camera",
        name93: "Camera Serial Number",
        name94: "Camera IP",
        name95: "Supervised",
        name96: "Lock Connection Type",
        name97: "Lock Connection Address",
        name98: "Enter Lock Connection Address",
        name99: "Lock Connection Port",
        name100: "Enter Lock Connection Port",
        name101: "IO Port Number",
        name102: "Enter IO Port Number",
        name103: "Smart Cabinet Door",
        name104: "Select Smart Cabinet Door",
        name105: "Display?",
        name106: "Select Cabinet Type",
        name107: "Exception",
        name108: "Subordinate to a total of",
        name109: "Smart Cabinets",
        name110: "Confirm Remote Inventory!",
        name111: "Inventory Successful!",
        name112: "Storage Attribute",
        name113: "Select Storage Attribute",
        name114: "Location Settings",
        name115: "Display?",
        name116: "Storage Cabinet (with Screen)",
        name117: "Storage Cabinet (without Screen)",
        name118: "MQ Connection (Default)",
        name119: "WIFI Relay",
        name120: "Independent Key Box",
        name121: "Bluetooth Lock",
        name122: "Confirm Face Sync!",
        name123: "Face Sync Successful!",
        name124: "Laboratory",
        name125: "Warehouse",
        name126: "No need for supervision",
        name127: "One Verification",
        name128: "2 verifications",
    },
    door: {
        name01: "Cabinet Door Name",
        name02: "Cabinet Door Number",
        name03: "Edit Cabinet Door Information",
        name04: "Modification Successful!",
        name05: "Cabinet Door",
        name06: "Confirm Authorization",
        name07: "Confirm Deauthorization",
        name08: "Smart Cabinet",
        name09: "Select Stock In Cabinet Door",
        name10: "Stock In Cabinet Door",

    },
    user: {
        name01: "User Information:",
        name02: "User Card Number",
        name03: "Enter Card Number",
        name04: "User Name",
        name05: "Enter Name",
        name06: "Email",
        name07: "Enter Email",
        name08: "User ID",
        name09: "Enter User ID",
        name10: "Mobile Number",
        name11: "Enter Mobile Number",
        name12: "College",
        name13: "Select College",
        name14: "Password Settings:",
        name15: "Username",
        name16: "Enter Username",
        name17: "Password",
        name18: "Enter Password",
        name19: "Confirm Password",
        name20: "Re-enter Password",
        name21: "Permission Settings:",
        name22: "Select Role",
        name23: "Borrowing Permission",
        name24: "Select Hazard Category",
        name25: "Authorize",
        name26: "Authorization Expiry Date",
        name27: "Select Authorization Expiry Date",
        name28: "Card Number cannot be empty",
        name29: "Username cannot be empty",
        name30: "Password length cannot be less than 6 characters",
        name31: "Passwords do not match",
        name32: "Enter Name",
        name33: "Enter a valid Email",
        name34: "Username cannot be empty",
        name35: "Enter a valid Mobile Number",
        name36: "cannot be empty",
        name37: "cannot be empty",
        name38: "Edit Personnel",
        name39: "Add Personnel",
        name40: "Successfully Updated User Information!",
        name41: "Successfully Added User Information!",
        name42: "Confirm Deletion of this Personnel Information!",
        name43: "Delete Personnel Information",
        name44: "Successfully Deleted Personnel Information!",
        name45: "Administrator",
        name46: "Operator",
        name47: "Role",
        name48: "Employee ID/Username",
        name49: "Edit Door Access Permission",
        name50: "Open Door",
        name51: "*",
        name52: "Status",
        name53: "Reagent Responsible",
        name54: "Reagent User",
        name55: "Select Status",
        name56: "Select Responsible Person",
        name57: "Select Reagent User",
        name58: "Personnel Information",
        name59: "List of cabinet doors that can be opened after approval of reagent pickup application",
        name60: "Authorize",
        name61: "List of cabinet doors that can be manually opened in the admin panel",
        name62: "Default",
        name63: "List of cabinet doors automatically authorized to be opened in the smart cabinet",
        name64: "Card number cannot start with 0",
        name65: "Door Access Permission",
        name66: "Enable",
        name67: "Enter Username",
        name68: "Photo MD5",
        name69: "Photo",
        name70: "Has Feature Value",
        name71: "Confirm deletion of this facial information?",
        name72: "Delete Facial Information",
        name73: "Upload Photo",
        name74: "Edit Facial Information",
        name75: "Add Facial Information",
        name76: "User",
        name77: "Are you sure you want to delete?",
        name78: "Role Name",
        name79: "Role Level",
        name80: "Enter Role Name",
        name81: "Enter Sorting",
        name82: "Level",
        name83: "Enter Level",
        name84: "Permission List Information",
        name85: "Select All/Deselect All",
        name86: "Loading, please wait",
        name87: "Edit Role Information",
        name88: "Add Role Information",
        role_code: "Role Code",
        input_role_code: "please enter role code",
        please_select_status: "Please select user status",
        user_status: "User status"


    },
    materiel: {
        name01: "Reagent Information",
        name02: "Batch Number",
        name03: "Please enter the batch number",
        name04: "RFID Number",
        name05: "Please enter the RFID number",
        name06: "Weighing",
        name07: "Do you need weighing",
        name08: "Gross Weight",
        name09: "Please enter the gross weight",
        name10: "Net Content",
        name11: "Please enter the net content",
        name12: "Bottle Weight",
        name13: "Please enter the bottle weight",
        name14: "Inbound Information",
        name15: "Production Date",
        name16: "Select the production date",
        name17: "Expiration Date",
        name18: "Select the expiration date",
        name19: "Manufacturer",
        name20: "Please select the manufacturer",
        name21: "Remarks",
        name22: "Please enter remarks",
        name23: "Disposal Status",
        name24: "* Indicates required fields",
        name25: "RFID number cannot be empty",
        name26: "Please enter the bottle weight",
        name27: "Please enter a non-negative number",
        name28: "Please enter the gross weight",
        name29: "Please enter the net content",
        name30: "Please enter the density",
        name31: "Please enter the specifications",
        name32: "Edit Reagent",
        name33: "Add Reagent",
        name34: "Are you sure you want to dispose of this reagent?",
        name35: "Confirm",
        name36: "Cancel",
        name37: "Prompt",
        name38: "Confirm deletion of this reagent information!",
        name39: "Delete Reagent Information",
        name40: "Successfully deleted reagent information!",
        name41: "Product Name/CAS Number",
        name42: "Disposal Time",
        name43: "Last Record Time",
        name44: "Copy",
        name45: "Permissions",
        name46: "Bottle weight cannot be less than 0!",
        name47: "Inbound Time",
        name48: "Disposal Request",
        name49: "Disposed Reagents",
        name50: "Applicant",
        name51: "Application Time",
        name52: "Approval Status",
        name53: "Unreviewed",
        name54: "Approved",
        name55: "Not Approved",
        name56: "Approver",
        name57: "Approval Time",
        name58: "Approve",
        name59: "Reject",
        name60: "Product Name/English Name/CAS Number",
        name61: "Please select the product name",
        name62: "Distribution Chart",
        name63: "There are",
        name64: "reagents in the smart cabinet",
        name65: "Export to Excel",
        name66: "Category",
        name67: "Net Content",
        name68: "Total Bottle Count",
        name69: "Details",
        name70: "Alert",
        name71: "Bottles",
        name72: "Reagent Not Weighed Upon Return",
        name73: "Reagent",
        name74: "Days Until Expiry",
        name75: "Reagent Expired",
        name76: "Distribution Information",
        name77: "Barcode",
        name78: "Please enter Barcode",
        name79: "Location",
        name80: "Please enter Location",
        name81: "Short Location",
        name82: "Please enter Short Location",
        name83: "Please select the custodian location",
        name84: "Owner",
        name85: "Please select the shortLocation",
        name86: "Please select the owner",
        name87: "Show by Number",
        name88: "Show by Product Name",
        name89: "Smart Cabinet Manager",
        name90: "Please select the Smart Cabinet Manager",
        name91: "Bottle Weight Reference Information",
        name92: "Edit Content:",
        name93: "Responsible Person",
        name94: "Please select the responsible person",
        name95: "Weighing Required",
        name96: "Inbound Cabinet",
        name97: "Please select the inbound cabinet",
        name98: "Bulk Inbound",
        name99: "Manager Information",
        name100: "Reagent Configuration Information",
        name101: "Reagent Details Information",
        name102: "Please select the manager information",
        name103: "Please select the reagent configuration information",
        name104: "Location Information",
        name105: "Are you sure you want to delete this reagent?",
        name106: "Please complete the selection of the first item, responsible person and department",
        name107: "Please complete the selection of the second item, reagent configuration",
        name108: "Configuration not found? Please first",
        name109: "Add Configuration",
        name110: "Please fill in the reagent details information",
        name111: "Both net content and bottle weight must be filled in!",
        name112: "The door of a multi door cabinet cannot be empty!",
        name113: "School/Department",
    },
    error: {
        name01: "All Rights Reserved",
        name02: "Please check if the entered URL is correct. Click the button below to return to the homepage or send an error report.",
        name03: "Back to Homepage",
        name04: "XX says you can't access this page...",
    },
    alarm: {
        name01: "Please select the Smart Cabinet",
        name02: "Employee ID/Name/Username/Reagent Name",
        name03: "Personnel",
        name04: "Smart Cabinet Number",
        name05: "Event",
        name06: "Time",
        name07: "Delete Selected",
        name08: "Delete All",
        name09: "All Smart Cabinets",
        name10: "Confirm deletion of violation information!",
        name11: "Delete Violation Information",
        name12: "Successfully deleted violation information!",
        name13: "Handling Comments",
        name14: "Resolved",
        name15: "Unresolved",
        name16: "Record",
        name17: "Notify",
        name18: "Threshold",
        name19: "Notification Type",
        name20: "Notification Recipient Type",
        name21: "Notification Recipients",
        name22: "Reporter",
        name23: "Report Time",
        name24: "Report Explanation",
        name25: "Report Image",
        name26: "Handle",
        name27: "Add Exception Tag",
        name28: "Edit Exception Tag",
        name29: "Please enter handling comments",
        name30: "Please enter the exception type name",
        name31: "Handling Violation Records",
        name32: "Is notification enabled",
        name33: "record",
        name34: "Not filled in",
        name35: "deregulation",
        name36: "early warning",
        name37: "Notification object",
        name38: "Handling Exceptions",
        name39: "Exception label name cannot be empty!",
        name40: "Indeed delete the exception label",
        name41: "Delete Exception Tags",
    },
    search: {
        name01: "Reagent Search",
        name02: "Employee's Reagent Search",
        name03: "RFID Number/Product Name/CAS Number",
        name04: "RFID Number",
        name05: "Status",
        name06: "Not Borrowed",
        name07: "Borrowed",
        name08: "Purchased",
        name09: "Location",
        name10: "Last Contact Person",
        name11: "Last Record Time",
        name12: "Circulation Details",
        name13: "Click to view",
        name14: "Employee ID/Name/Username",
        name15: "Username",
        name16: "Name",
        name17: "Current Holding Quantity",
        name18: "Borrowed Quantity",
        name19: "Borrowing Times",
        name20: "Return Times",
        name21: "Circulation Information",
        name22: "Name:",
        name23: "Number:",
        name24: "Status:",
        name25: "Not Borrowed",
        name26: "In Cabinet:",
        name27: "Net Content:",
        name28: "Net Content",
        name29: "Not Weighed",
        name30: "Purchased",
        name31: "Inbound",
        name32: "Borrowed",
        name33: "Returned",
        name34: "Disposed",
        name35: "Reagent Search",
        name36: "Apply",
        name37: "Review",
    },
    report: {
        name01: "Hazardous Chemical Monthly Report",
        name02: "Hazardous Chemical Issuance Report",
        name03: "Chemical Monthly Report",
        name04: "Chemical Inventory Report",
        name05: "Date",
        name06: "Incoming Quantity",
        name07: "Outgoing Quantity",
        name08: "Inventory Quantity",
        name09: "Reagent Number",
        name10: "Operator",
        name11: "Usage Quantity",
        name12: "Operation Type",
        name13: "Smart Cabinet Name",
        name14: "Please Select Reagent",
        name15: "Display by Single Bottle",
        name16: "By single display",
        name17: "Location",
        name18: "Group by Name",
        name19: "Group by Name",
        name20: "Public Security Ledger",
        name21: "Supervisor",
        name22: "Reason",
        name23: "Supervisor",
        name24: "Remaining Quantity",
        name25: "Please enter reagent name/RFID",
        name26: "Please select the operation type",
        name27: "Please select the operator",
        name28: "Sort by time",
        name29: "Operation content",
        name30: "View video recordings",
        name31: "Please enter the name of the reagent product",
        amount_purchased:"Amount Purchased",
        cancellation_amount:"Cancellation Amount",
        adjustment_amount:"Adjustment Amount",
        total_margin:"Total Margin",
        total_quantity_in_storage:"Total Quantity In Storage"
    },
    company: {
        name01: "Company Name",
        name02: "Edit Company Information",
        name03: "Add Company Information",
        name04: "Please Enter Company Name!",
        name05: "Company Name cannot be empty",
        name06: "Delete Company Information",
        name07: "Confirm deletion of this company information!",
        name08: "Company Information deleted successfully!",
        name09: "Add New Company Information",
        name10: "Functional Configuration Item",
        name11: "Department Name",
        name12: "Configuration Item",
        name13: "Configuration Name",
        name14: "Configuration Key",
        name15: "Configuration Type",
        name16: "Default",
        name17: "Filling Requirements",
        name18: "Configuration Value",
        name19: "Edit System Configuration Item Information",
        name20: "Add System Configuration Item Information",
        name21: "General Configuration",
        name22: "Super Admin Configuration Only",
        name23: "Please Select Company",
        name24: "Please Select Configuration Type",
        name25: "Please enter the key",
        name26: "Is it only for super management configuration",
        name27: "User Name",
        name28: "Company Type",
        name29: "Edit New Company Information",

    },
    department: {
        name01: "College Name",
        name02: "Edit",
        name03: "Add",
        name04: "Please Enter Name!",
        name05: "Name cannot be empty",
        name06: "Delete Information",
        name07: "Confirm deletion of this information!",
        name08: "Information deleted successfully!",
        name09: "Please Select Department/College",
        name10: "Student ID",
        name11: "Please enter student ID",
        name12: "College Information",
        name13: "Department",
        name14: "Please Select Department",
        name15: "Job ID",
        name16: "Please enter the job number",
        name17: 'Department Information'
    },
    setting: {
        name01: "Warning Items",
        name02: "Data",
        name03: "Notify Fixed Email",
        name04: "Notify Violator",
        name05: "Low Inventory Ratio (%)",
        name06: "Admin Reagent Issuance Limit",
        name07: "Operator Reagent Issuance Limit",
        name08: "Reagent Overdue Return (hours)",
        name09: "Max Idle Time in Cabinet (days)",
        name10: "Cabinet Open Time Limit (minutes)",
        name11: "Record Unweighed Items",
        name12: "Record Unauthorized Reagent Acquisition",
        name13: "Time to Weigh Before Return (seconds)",
        name14: "Expiry Warning Period (days)",
        name15: "Hours",
        name16: "Days",
        name17: "Minutes",
        name18: "Please Enter Low Inventory Ratio (%)",
        name19: "Low Inventory Ratio Notification Email",
        name20: "Please Enter Low Inventory Ratio Notification Email (multiple emails separated by ;)",
        name21: "Please Enter Admin Reagent Issuance Limit",
        name22: "Admin Reagent Issuance Limit Notification Email",
        name23: "Please Enter Admin Reagent Issuance Limit Notification Email (multiple emails separated by ;)",
        name24: "Notify Violator for Admin Reagent Issuance Limit",
        name25: "Please Enter Operator Reagent Issuance Limit",
        name26: "Operator Reagent Issuance Limit Notification Email",
        name27: "Please Enter Operator Reagent Issuance Limit Notification Email (multiple emails separated by ;)",
        name28: "Notify Violator for Operator Reagent Issuance Limit",
        name29: "Please Enter Reagent Overdue Return Limit",
        name30: "Reagent Overdue Return Notification Email",
        name31: "Please Enter Reagent Overdue Return Notification Email (multiple emails separated by ;)",
        name32: "Notify Violator for Reagent Overdue Return",
        name33: "Please Enter Max Idle Time in Cabinet",
        name34: "Max Idle Time in Cabinet Notification Email",
        name35: "Please Enter Max Idle Time in Cabinet Notification Email (multiple emails separated by ;)",
        name36: "Cabinet Open Time Limit",
        name37: "Cabinet Open Time Limit Notification Email",
        name38: "Please Enter Cabinet Open Time Limit Notification Email (multiple emails separated by ;)",
        name39: "Notify Violator for Cabinet Open Time Limit",
        name40: "Please Enter Time to Weigh Before Return (in seconds)",
        name41: "Unweighed Before Return Notification Email",
        name42: "Please Enter Unweighed Before Return Notification Email (multiple emails separated by ;)",
        name43: "Notify Violator for Unweighed Before Return",
        name44: "Expiry Notification Email",
        name45: "Please Enter Expiry Notification Email (multiple emails separated by ;)",
        name46: "Unweighed Notification Email",
        name47: "Please Enter Unweighed Notification Email (multiple emails separated by ;)",
        name48: "Notify Violator for Unweighed",
        name49: "Record Unauthorized Reagent Acquisition",
        name50: "Unauthorized Reagent Acquisition Notification Email",
        name51: "Please Enter Unauthorized Reagent Acquisition Notification Email (multiple emails separated by ;)",
        name52: "Notify Violator for Unauthorized Reagent Acquisition",
        name53: "Admin Reagent Issuance Limit cannot be empty",
        name54: "Admin Reagent Issuance Limit cannot be negative",
        name55: "Reagent Overdue Return Limit cannot be empty",
        name56: "Reagent Overdue Return Limit cannot be negative",
        name57: "Cabinet Open Time Limit cannot be empty",
        name58: "Cabinet Open Time Limit cannot be negative",
        name59: "Max Idle Time in Cabinet cannot be empty",
        name60: "Max Idle Time in Cabinet cannot be negative",
        name61: "Operator Reagent Issuance Limit cannot be empty",
        name62: "Operator Reagent Issuance Limit cannot be negative",
        name63: "Max Quantity in Smart Cabinet cannot be empty",
        name64: "Max Quantity in Smart Cabinet cannot be negative",
        name65: "Seconds",
        name66: "Warning Configuration",
        name67: "VOC Threshold",
        name68: "VOC Alarm Notification Email",
        name69: "VOC Alarm Notification Email (multiple emails separated by ;)",
        name70: "Door Opening Timeout",
        name71: "Please Enter Door Opening Timeout",
        name72: "Temperature Upper Limit for Warning",
        name73: "Please Enter Temperature Upper Limit for Warning",
        name74: "Temperature Lower Limit for Warning",
        name75: "Please Enter Temperature Lower Limit for Warning",
        name76: "Humidity Upper Limit for Warning",
        name77: "Please Enter Humidity Upper Limit for Warning",
        name78: "Humidity Lower Limit for Warning",
        name79: "Please Enter Humidity Lower Limit for Warning",
        name80: "VOC Upper Limit for Warning",
        name81: "Please Enter VOC Upper Limit for Warning",
        name82: "Maximum Storage Quantity",
        name83: "Please Enter Maximum Storage Quantity",
        name84: "Default Authorization for Door Opening",
        name85: "Default Authorization for Door Opening",
        name86: "Follow Smart Cabinet",
        name87: "Enable Attribute Conflict Detection",
        name88: "Follow System",
        name89: "Authorize to Sub-Departments",
        name90: "Enable Reagent Attribute Conflict Detection",
        name91: "Interval for Continuous Alarm Push (s)",
        name92: "Configuration Item",
        name93: "Configuration Data",
        name94: "Select File",










    },
    danger: {
        name01: "Name",
        name02: "Please Enter Hazardous Category Name",
        name03: "Edit Hazardous Category Configuration",
        name04: "Add Hazardous Category Configuration",
        name05: "Confirm deletion of this Hazardous Category configuration!",
        name06: "Delete Hazardous Category Configuration",
        name07: "Hazardous Category Configuration deleted successfully!",
        name08: "Hazardous Category Name cannot be empty!",
        name09: "Is it a Hazardous Chemical",
        name10: "Is it a Controlled Category",
        name11: "Please Enter Hazardous Category Number",
        name12: "Controlled Category",
    },
    cas: {
        name01: "Product Name/English Name/CAS Number",
        name02: "Product Name",
        name03: "English Name",
        name04: "CAS Number",
        name05: "MSDS",
        name06: "Form",
        name07: "Liquid (ml)",
        name08: "Solid (g)",
        name09: "Density",
        name10: "Specification",
        name11: "Hazard Category",
        name12: "Other Description",
        name13: "Please Enter Product Name",
        name14: "Please Enter English Name",
        name15: "Please Enter CAS Number",
        name16: "Select Reagent Form",
        name17: "Liquid Density (g/ml)",
        name18: "Enter Specification (g)",
        name19: "Enter Specification (ml)",
        name20: "Select Hazard Category",
        name21: "g/ml",
        name22: "Enter Other Description",
        name23: "Edit Product Name Configuration",
        name24: "Add Product Name Configuration",
        name25: "Confirm deletion of this Product Name configuration!",
        name26: "Delete Product Name Configuration",
        name27: "Product Name Configuration deleted successfully!",
        name28: "Product Name cannot be empty!",
        name29: "ml",
        name30: "g",
        name31: "MSDS URL",
        name32: "Sample Name",
        name33: "Sample Name in Chinese",
        name34: "Please enter Sample Name",
        name35: "Please enter Sample Name in Chinese",
        name36: "Chinese Alias",
        name37: "English Alias",
        name38: "Enter Chinese Alias",
        name39: "Enter English Alias"




    },
    manufacturer: {
        name01: "Name",
        name02: "Manufacturer Name",
        name03: "Manufacturer Code",
        name04: "Contact Person",
        name05: "Contact Number",
        name06: "Please Enter Manufacturer Name",
        name07: "Please Enter Manufacturer Code",
        name08: "Please Enter Contact Person",
        name09: "Please Enter Contact Number",
        name10: "Manufacturer Name cannot be empty",
        name11: "Edit Manufacturer Configuration",
        name12: "Add Manufacturer Configuration",
        name13: "Confirm deletion of this Manufacturer configuration!",
        name14: "Delete Manufacturer Configuration",
        name15: "Manufacturer Configuration deleted successfully!",
    },
    sensor: {
        name01: "Field Name",
        name02: "Is Visible",
        name03: "Show",
        name04: "Hide",
        name05: "Name",
    },
    mail: {
        name01: "Email Test",
        name02: "Email Configuration",
        name03: "Data",
        name04: "Email Server Address",
        name05: "Email Server Port",
        name06: "Email",
        name07: "Email Password",
        name08: "Enable SSL",
        name09: "Is Exchange Email Service",
        name10: "Settings modified successfully!",
        name11: "Please Enter Email Server Address",
        name12: "Please Enter Email Server Port",
        name13: "Please Enter Email",
        name14: "Please Enter Email Password",
        name15: "Test Email",
        name16: "Please Enter Test Email Address",
        name17: "Email sent successfully!",
        name18: "Email"
    },
    apk: {
        name01: "APK Version Number/Name",
        name02: "Version",
        name03: "Version Address",
        name04: "Click to Download",
        name05: "Version Description",
        name06: "Uploader",
        name07: "Upload Time",
        name08: "APK File",
        name09: "Only APK files are allowed. Drag and drop files here or",
        name10: "Click to Upload",
        name11: "APK Version Name",
        name12: "Please Enter APK Version Name",
        name13: "APK Description",
        name14: "Please Enter APK Description",
        name15: "APK Version Name cannot be empty!",
        name16: "Edit APK Version Information",
        name17: "Add APK Version Information",
        name18: "APK File Uploaded Successfully!",
        name19: "Confirm deletion of this APK Version information!",
        name20: "Delete APK Version Information",
        name21: "APK Version Information deleted successfully!",
        name22: "Download Address",
        name23: "Please Enter Download Address",
        name24: "APK Type",
        name25: "Please Select APK Type"
    },
    log: {
        name01: "Smart Cabinet Number",
        name02: "Log Name",
        name03: "Server Upload Time",
        name04: "Download Log",
        name05: "Confirm deletion of this log information!",
        name06: "Delete Log Information",
        name07: "Log Information deleted successfully!",
    },
    apply: {
        name01: "Door Opening Request",
        name02: "Disposal Request",
        name03: "Request Approved",
        name04: "Request Rejected",
        name05: "Review Comment",
        name06: "Please Enter Review Comment",
        name07: "Delete Application Information",
        name08: "Confirm deletion of application information!",
        name09: "Application information deleted successfully!",
        name10: "Apply",
        name11: "Apply for Disposal",
        name12: "Confirm applying for the disposal of this reagent!",
        name13: "Application Reason",
        name14: "Please Enter Application Reason!",
        name15: "Valid Count",
        name16: "Please Select Valid Count!",
    },
    materielDoor: {
        name01: "Edit Reagent Designated Storage Information",
        name02: "Reagent Information",
        name03: "Storage Location",
        name04: "Confirm to Store in",
        name05: "Smart Cabinet!",
        name06: "Confirm to Cancel Storage in",
        name07: "Modified Reagent Designated Storage Information successfully!",
        name08: "Please Select Storage Location",
        name09: "Designated Cabinet",
        name10: "Please Select Designated Cabinet",
        name11: "Designated Cabinet Door",
        name12: "Please Select Designated Cabinet Door",
        name13: "Store Immediately"



    },
    inventory: {
        name01: "Inventory Personnel",
        name02: "Inventory Time",
        name03: "Inventory Cabinet",
        name04: "Inventory Cabinet Door",
        name05: "Inventory Loss",
        name06: "Inventory Gain",
        name07: "Details",
        name08: "Please Select Inventory Cabinet",
        name09: "Please Select Inventory Personnel",
        name10: "Sample Name",
        name11: "Chinese Sample Name",
        name12: "CAS Number",
        name13: "Barcode",
        name14: "RFID Number",
        name15: "Quantity",
        name16: "Owner",
        name17: "Location",
        name18: "Short Distance",
        name19: "Registration Date",
        name20: "Location (Current)",
        name21: "Short Distance (Current)",
        name22: "Inventory Type",
        name23: "Reagent Name",
        name24: "Please Select Inventory Type",
        name25: "Inventory Result",
        name26: "Normal",
        name27: "Reagent Quantity"
    },
    receive: {
        name01: 'Agree',
        name02: 'Disagree',
        name03: 'Click for Details',
        name04: 'Add Reagent Application',
        name05: 'Edit Application Information',
        name06: "Cancel Application",
        name07: "Reject Review",
        name08: "Approve Review",
        name09: "Withdraw Application",
        name10: "Review Cancellation"

    },
    largeScreen: {
        name01: "Smart Cabinet Visualization Platform",
        name02: "Enter Backend System",
        name03: "Swipe Left",
        name04: "Swipe Right",
        name05: "Total Smart Cabinets",
        name06: "Total Reagents",
        name07: "Total Personnel",
        name08: "Inventory Data Statistics Chart",
        name09: "Usage Data Statistics Chart",
        name10: "Violation Records",
        name11: "Reagent Categories",
        name12: "Reagent Properties",
        name13: "Withdrawal Records",
        name14: "Operation Records",
        name15: "Sunday",
        name16: "Monday",
        name17: "Tuesday",
        name18: "Wednesday",
        name19: "Thursday",
        name20: "Friday",
        name21: "Saturday",
        name22: "Sunday",
        name23: "Reagent Name",
        name24: "CAS Number",
        name25: "RFID Number",
        name26: "Owner",
        name27: "Net Content",
        name28: "Bottle Weight",
        name29: "Attribute",
        name30: "Category",
        name31: "Status",
        name32: "Purchased",
        name33: "In Cabinet",
        name34: "Borrowed",
        name35: "Disposed",
        name36: "Usage",
        name37: "Inventory",
        name38: 'Purchased'
    },
    attribute: {
        name01: "Please Select Reagent Property",
        name02: "Conflicting Reagents",
        name03: "Please Select Conflicting Reagents",
        name04: "System Default",
        name05: "Confirm deletion of reagent configuration information",
        name06: " Note: Deletion may cause errors in reagent categorization and statistics!",
        name07: "Mutual Exclusion Property",
        name08: "Property Name",
        name09: "Please Enter Property Name",
        name10: "Please Select Mutual Exclusion Property",
        name11: "Property Name cannot be empty!",
        name12: "Edit Reagent Property",
        name13: "Add Reagent Property",
        name14: "Confirm deletion of this reagent property information",
        name15: "Delete Reagent Property Information",
        name16: "Deletion Successful",
        name17: "Set successfully",
        name18: "Edit Successful",
    },
    placeholder: {
        name01: 'Please Enter Content',
        name02: "Please Select",
        name03: 'Please Enter'
    },
    keyBox: {
        name01: "Key Name",
        name02: "Identifier",
        name03: "Status",
        name04: "Open",
        name05: "Discard",
        name06: "Type",
        name07: "Regular Key",
        name08: "Card",
        name09: "Bind Smart Cabinet",
        name10: "Store in Smart Cabinet",
        name11: "Smart Cabinet Door",
        name12: "Key Status",
        name13: "Edit Key Box Information",
        name14: "Add Key Box Information",
        name15: "Is it inside the cabinet",
        name16: "Status Type",
        name17: "Key Type",
    },
    print: {
        name01: 'Printer',
        name02: 'Please Select Printer',
        name03: 'Print Details',
        name04: "Printer Name/IP",
        name05: "Connection Type",
        name06: "Network",
        name07: "Device Type",
        name08: "Zebra RFID Printer",
        name09: "ZMIN RFID Printer",
        name10: "RD Barcode Printer",
        name11: "Print Depth",
        name12: "Print Speed",
        name13: "Port",
        name14: "X-Axis Offset",
        name15: "Y-Axis Offset",
        name16: "Associate with Smart Cabinet",
        name17: "Name",
        name18: "Printer Name",
        name19: "Please Enter Printer Name",
        name20: "Please Select Type",
        name21: "Please Enter Device Type",
        name22: "Please Enter Print Depth",
        name23: "Please Enter Print Speed",
        name24: "IP Address",
        name25: "Please Enter IP Address",
        name26: "Port Number",
        name27: "Please Enter Port Number",
        name28: "Please Enter X-Axis Offset",
        name29: "Please Enter Y-Axis Offset",
        name30: "Select Print Template",
        name31: "Please Select Associated Smart Cabinet",
        name32: "Edit Printer Information",
        name33: "Add Printer Information",
        name34: "Confirm deletion of printer information!",
        name35: "Delete Printer",
    },
    upload: {
        name01: 'Reagent File',
        name02: 'Only upload XLSX files, drag the file here, or',
        name03: 'Click to Upload',
        name04: 'Download Template',
        name05: 'Total Error Messages',
        name06: "items, please modify and re-upload!",
        name07: "Error Reasons",
        name08: "Excel Line Number",
        name09: "Upload Reagents",
        name10: "Reagents Imported Successfully!",
        name11: "Uploaded file must be in XLSX format!",
        name12: "Only upload Excel files, drag the file here, or",
        name13: "Error Messages",
        name14: "Import Successful!",
        name15: "Uploaded file must be in XLSX format",
        name16: "Only upload jpg/png files",
        name17: "Instructions",
        name18: "1. Name the photo with the user's name, e.g., Zhang San",
        name19: "2. If names are duplicated, A unique and non-repetitive identifier needs to be added, e.g., Zhang San_123"


    },
    msds: {
        name01: "CAS Number/Name",
        name02: "Chemical Name (Chinese)",
        name03: "Chemical Name (English)",
        name04: "Safety Data Sheet",
        name05: "Part 1: Chemical Name",
        name06: "Chinese Name of the Chemical:",
        name07: "Common Name of the Chemical:",
        name08: "English Name of the Chemical:",
        name09: "English Name:",
        name10: "Technical Data Sheet Code:",
        name11: "Manufacturer Name:",
        name12: "Address:",
        name13: "Effective Date:",
        name14: "Part 2: Hazard Overview",
        name15: " Hazard Category:",
        name16: "Route of Entry:",
        name17: "Health Hazard:",
        name18: "Environmental Hazard:",
        name19: "Explosive Hazard:",
        name20: "Part 3: Composition/Information on Ingredients",
        name21: "Hazardous Component",
        name22: "Content",
        name23: "Part 4: First Aid Measures",
        name24: "Skin Contact:",
        name25: "Eye Contact:",
        name26: "Inhalation:",
        name27: "Ingestion:",
        name28: "Part 5: Firefighting Measures",
        name29: "Hazard Characteristics:",
        name30: " Hazardous Combustion Products:",
        name31: "Extinguishing Methods:",
        name32: "Part 6: Leak Emergency Handling",
        name33: "Emergency Handling:",
        name34: "Part 7: Operation, Disposal, and Storage",
        name35: " Operation Cautions:",
        name36: "Storage Cautions:",
        name37: "Part 8: Exposure Control/Personal Protection",
        name38: " China MAC (mg/m3):",
        name39: "Former Soviet Union MAC (mg/m3):",
        name40: "Monitoring Method:",
        name41: "Engineering Controls:",
        name42: "Respiratory Protection:",
        name43: "Eye Protection:",
        name44: "Body Protection:",
        name45: "Hand Protection:",
        name46: "Other Protections:",
        name47: "Part 9: Physical and Chemical Properties",
        name48: 'Appearance and Character:',
        name49: "Melting Point (℃):",
        name50: "Relative Density (water=1):",
        name51: "Boiling Point (℃):",
        name52: "Relative Vapor Density (air=1):",
        name53: "Molecular Formula:",
        name54: "Molecular Weight:",
        name55: "Main Components:",
        name56: "Saturated Vapor Pressure (kPa):",
        name57: "Combustion Heat (kJ/mol):",
        name58: "Critical Temperature (℃):",
        name59: "Critical Pressure (MPa):",
        name60: "Logarithm of Octanol/Water Partition Coefficient:",
        name61: "Flash Point (℃):",
        name62: "Explosion Upper Limit %(V/V):",
        name63: "Ignition Temperature (℃):",
        name64: "Explosion Lower Limit %(V/V):",
        name65: "Solubility:",
        name66: "Main Uses:",
        name67: "Other Physical and Chemical Properties:",
        name68: "Part 10: Stability and Reactivity",
        name69: "Stability:",
        name70: "Incompatible Materials:",
        name71: "Conditions to Avoid:",
        name72: "Hazardous Polymerization:",
        name73: "Decomposition Products:",
        name74: "Part 11: Toxicological Information",
        name75: "Acute Toxicity:",
        name76: "Subacute and Chronic Toxicity:",
        name77: "Irritation:",
        name78: "Sensitization:",
        name79: "Mutagenicity:",
        name80: "Teratogenicity:",
        name81: "Carcinogenicity:",
        name82: "Part 12: Ecological Information",
        name83: "Ecotoxicity:",
        name84: " Biodegradability:",
        name85: " Non-biodegradability:",
        name86: " Bioaccumulative Potential:",
        name87: " Other Harmful Effects:",
        name88: "Part 13: Disposal Considerations",
        name89: "Waste Characteristics:",
        name90: " Disposal Methods:",
        name91: " Waste Handling Precautions:",
        name92: "Part 14: Transportation Information",
        name93: "Hazardous Goods Number:",
        name94: "UN Number:",
        name95: "Packaging Markings:",
        name96: "Packaging Category:",
        name97: "Packaging Methods:",
        name98: " Transport Handling Precautions:",
        name99: "Part 15: Regulatory Information",
        name100: "Regulatory Information:",
        name101: "Part 16: Other Information",
        name102: "References:",
        name103: "Filling Department:",
        name104: "Data Review Unit:",
        name105: "Modification Description:",
        name106: "Other Information:",
        name107: "MSDS not found",
        name108: "Confirm deletion of this MSDS information!",
        name109: "Delete MSDS information",
        name110: 'Deletion successful',
    },
    purchaseOrder: {
        name01: "Storage Status",
        name02: "Purchase Order Number",
        name03: "Store by Selected Purchase Order",
        name04: "Export by Selected Purchase Order",
        name05: "Print by Selected Purchase Order",
        name06: "Batch Export",
        name07: "Batch Print",
        name08: "Purchase Order Number",
        name09: "Initiation Time",
        name10: "In Approval",
        name11: "Approval Failed",
        name12: "Approval Successful",
        name13: "Cancel Approval",
        name14: "Initiator",
        name15: "Initiator Contact Information",
        name16: "Purchase Order Contact Information",
        name17: "Purchase Details",
        name18: "Research Group",
        name19: "Project Admission Number",
        name20: "Not In Storage",
        name21: "In Storage",
        name22: "Approval Status",
        name23: "Storage Cancellation",
        name24: "Storage Successful",
    },
    video: {
        name01: "End Time of Recording",
        name02: "Start Time of Recording",
        name03: "Total Duration",
        name04: "Play Video",
        name05: "Video List"
    },
    approval: {
        name01: "Reagent Addition",
        name02: "Reagent Usage",
        name03: "Reagent Withdrawal",
        name04: "Purchase Request",
        name05: "Project Admission Request",
        name06: "Code Supplement Request",
        name07: "Configuration Type",
        name08: "Global Configuration",
        name09: "Category Configuration",
        name10: "Configuration Name",
        name11: "Approval Steps",
        name12: "Approver",
        name13: "Personnel Approval:",
        name14: "Reagent Responsible Person Approval",
        name15: "Lab Administrator Approval",
        name16: "Role Approval:",
        name17: "Designate Reagents",
        name18: "Cabinet Responsible Person Approval",
        name19: "Approval Steps",
        name20: "Confirm Deletion of Approval Flow Information",
        name21: "Step",
        name22: "Click to Select Reagents",
        name23: "Only Local",
        name24: "Edit Approval Flow",
        name25: "Add Approval Flow",
        name26: "Designate Personnel",
        name27: "Designate Role",
        name28: "Lab Administrator",
        name29: "Cabinet Responsible Person",
        name30: "Pending Approval",
        name31: "Approval Records",
        name32: "Approval Details",
        name33: "Reagent Configuration Details",
        name34: "Application Records",
        name35: "Add Code Supplement Request",
        name36: "Edit Code Supplement Request",
        name37: "Please Enter Code Supplement Reason",
        name38: "Code Supplement Reason",
        name39: "Opcode",
        name40: "Approval details",
        name41: "Applied for",
        name42: "Approval results",
        name43: "Application has been issued",
        name44: "To be notified",
        name45: "Agreed",
        name46: "Refused",
        name47: "revoke",
        name48: "entry name",
        name49: "project",
        name50: "undergraduate teaching",
        name51: "Graduate teaching",
        name52: "Innovation projects",
        name53: "Research projects",
        name54: "Experimental project admission number",
        name55: "Edit project admission application",
        name56: "Add project admission application",
        name57: "withdraw",
        name58: "Reagent details",
        name59: "Chinese name of reagent",
        name60: "Reagent CAS number",
        name61: "record",
        name62: "Experimental location",
        name63: "Test date",
        name64: "Approval time",
        name65: "Chemical usage team",
        name66: "Purchasing reagents",
        name67: "Procurement details",
        name68: "Admission of experimental projects",
        name69: "Purchasing contact phone number",
        name70: "Cost number",
        name71: "Storage location cabinet",
        name72: "Specification value",
        name73: "Add purchase request",
        name74: "Application approval",
        name75: "List of reagents displayed only in the cabinet",
        name76: "Add Laboratory",
        name77: "Editing laboratory",
        name78: "applying",
        name79: "Specification value",
        name80: "unit"
    },
    supplier: {
        name01: "Supplier Bank Account",
        name02: "Supplier Bank Name",
        name03: "Supplier Contact Person's ID Card",
        name04: "In-house Contact Person's ID Card",
        name05: "In-house Contact Person",
        name06: "In-house Contact \nPerson's Phone",
        name07: "License Type",
        name08: "License Number",
        name09: "License Start Date",
        name10: "License End Date",
        name11: "Attachment",
        name12: "Supplier Name",
        name13: "Supplier Address",
        name14: "Supplier Contact Person's Name",
        name15: "Supplier Contact Person's Phone",
        name16: "Confirmed",
        name17: "Confirm Deletion of This Reagent Property Information!",
        name18: "Chemical Name",
        name19: 'supplier',
        name20: "Supplier to be confirmed",
        name21: "Hazardous Chemicals Business License",
        name22: "Supplier Details",
        name23: "To be determined",
        name24: "Attachment Type",
        name25: "Please select attachment type",
        name26: "Details of Hazardous Chemicals",
        name27: "Business License",
        name28: "Supplier contact person cannot be empty!",
        name29: "Supplier name cannot be empty！",
        name30: "Supplier Confirmation",
        name31: "Supplier's Reagent Details",
    },
    permission: {
        name01: "Menu Name",
        name02: "Request Method",
        name03: "Request Interface",
        name04: "Validation Method",
        name05: "Creation Time",
        name06: "Modification Time",
        name07: "Icon",
        name08: "Code",
        name09: "Component Path",
    },
    localSetting: {
        name01: "Specific Location",
        name02: "Select Superior",
        name03: "Please enter specific location",
        name04: "Select Type",
        name05: "Add Place",
        name06: "Editing Place"
    },
    confirm: {
        name01: "This operation will revoke the application. Do you want to continue?",
        name02: "Do you need to continue applying?",
        name03: "Do you need to continue entering?",
        name04: "Return this purchase order, do you want to continue?",
        name05: "Canceled Exit",
        name06: "Are you sure to select the purchase order for warehousing?",
        name07: "Please fill in the details of hazardous chemicals",
        name08: "Reason cannot be empty when rejecting approval",
        name09: "Product name cannot be empty",
    },
};


export default zh



// WEBPACK FOOTER //
// ./src/assets/languages/en.js